import _default from './Dropdown';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/modules/Dropdown/index.js
// module id = 229
// module chunks = 0